var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        size: "lg",
        "confirm-loading": _vm.loading,
        "confirm-text": "Lưu nhận xét",
        "cancel-text": "Đóng",
        "use-panel": true,
        "panel-title": "Nhận xét tuần",
        "panel-subtitle":
          "Tạo hoặc chỉnh sửa nhận xét tổng hợp theo tuần cho học sinh",
        "panel-icon": "el-icon-document",
        "panel-icon-tone": "success",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleSave,
        cancel: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "sk-u-mt-12",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sk-form-grid" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Học sinh", prop: "studentId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "Chọn học sinh",
                        filterable: "",
                        disabled: "",
                      },
                      on: { change: _vm.handleStudentChange },
                      model: {
                        value: _vm.dataForm.studentId,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "studentId", $$v)
                        },
                        expression: "dataForm.studentId",
                      },
                    },
                    _vm._l(_vm.studentList, function (item) {
                      return _c("el-option", {
                        key: item.studentId,
                        attrs: {
                          label: item.studentName,
                          value: item.studentId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tuần", prop: "fromDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "week",
                      "value-format": "yyyy-MM-dd",
                      format: "Tuần WW (từ dd/MM/yyyy)",
                      placeholder: "Chọn tuần",
                      clearable: false,
                      disabled: "",
                    },
                    on: { change: _vm.handleWeekPickerChange },
                    model: {
                      value: _vm.dataForm.fromDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "fromDate", $$v)
                      },
                      expression: "dataForm.fromDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Nội dung", prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 5,
                  placeholder: "Nhập nội dung nhận xét hoặc chọn mẫu ở trên...",
                  maxlength: "2000",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.dataForm.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "content", $$v)
                  },
                  expression: "dataForm.content",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "evl-upload-section" },
            [
              _c("div", { staticClass: "evl-upload-section__header" }, [
                _c("span", { staticClass: "evl-upload-title" }, [
                  _c("i", { staticClass: "el-icon-paperclip" }),
                  _vm._v(" File & hình ảnh đính kèm\n        "),
                ]),
                _c("span", { staticClass: "evl-upload-subtitle" }, [
                  _vm._v("Tối đa 3 file/nhận xét (Ảnh, Word, Excel hoặc PDF)"),
                ]),
              ]),
              _c(
                "el-upload",
                {
                  staticClass: "evl-drag-uploader",
                  attrs: {
                    drag: "",
                    action: "#",
                    "auto-upload": false,
                    "file-list": _vm.fileList,
                    limit: 3,
                    accept: "image/*,.pdf,.doc,.docx,.xls,.xlsx",
                    multiple: "",
                    "on-change": _vm.handleFileChange,
                    "on-remove": _vm.handleFileRemove,
                    "on-exceed": _vm.handleFileExceed,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("\n          Kéo thả file/ảnh vào đây hoặc "),
                    _c("em", [_vm._v("nhấn để chọn file")]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }